import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ArrayService {
    constructor() {
    }

    public orderByDisplayName( a, b ) {
        if ( a.displayName < b.displayName ) {
          return -1;
        }
        if ( a.displayName > b.displayName ) {
          return 1;
        }
        return 0;
    }

    public removeFromArray(objectArray: any[], toRemoveItem: any) {
      const removeIndex = objectArray.map ( (item) => item.id ).indexOf(toRemoveItem.id);
      objectArray.splice(removeIndex, 1);
      return objectArray;
    }
}
